import React from "react";
import OnlyPDFViewer from "./OnlyPDFViewer";

const PDFViewerModal = ({ fileUrl, onClose, message = "", ...restProps }) => {
  if (!fileUrl) return null;

  return (
    <OnlyPDFViewer
      fileUrl={fileUrl}
      onClose={onClose}
      message={message}
      {...restProps}
    />
  );
};

export default PDFViewerModal;
